import { TransactionResponse } from "../clients/transaction-client/model";

export interface TransactionViewModel {
    payoutId: string;
    payoutCreateDate: Date;
    payoutCurrency: string;
    payoutAmount: number;

    balanceTransactionId: string;
    transactionType: string;
    balanceTransactionCreateDate: Date;
    balanceTransactionCurrency: string;
    balanceTransactionAmount: number;

    chargeId: string | null;
    chargeCreateDate: Date | null;
    chargeCurrency: string | null;
    chargeAmount: number | null;
    invoiceId?: number;
    customerId?: number;
    orderId?: number;
    paymentIntentId: string | null;
    companyName: string | null;
    invoiceUq?: number;
    customerReference: string | null;
    paid?: boolean;
}

export function flattenTransactions(transactionResponse: TransactionResponse): TransactionViewModel[] {
    return transactionResponse.payoutModels.flatMap((payout) =>
        payout.balanceTransactions.map((balanceTransaction) => ({
            payoutId: payout.payoutId,
            payoutCreateDate: payout.createDate,
            payoutCurrency: payout.currency,
            payoutAmount: payout.amount,

            balanceTransactionId: balanceTransaction.balanceTransactionId,
            transactionType: balanceTransaction.transactionType,
            balanceTransactionCreateDate: balanceTransaction.createDate,
            balanceTransactionCurrency: balanceTransaction.currency,
            balanceTransactionAmount: balanceTransaction.amount,

            chargeId: balanceTransaction.transactionDetails?.chargeId ?? null,
            chargeCreateDate: balanceTransaction.transactionDetails?.createDate ?? null,
            chargeCurrency: balanceTransaction.transactionDetails?.currency ?? null,
            chargeAmount: balanceTransaction.transactionDetails?.amount ?? null,
            invoiceId: balanceTransaction.transactionDetails?.invoiceId,
            customerId: balanceTransaction.transactionDetails?.customerId,
            orderId: balanceTransaction.transactionDetails?.orderId,
            paymentIntentId: balanceTransaction.transactionDetails?.paymentIntentId ?? null,
            companyName: balanceTransaction.transactionDetails?.companyName ?? null,
            invoiceUq: balanceTransaction.transactionDetails?.invoiceUq,
            customerReference: balanceTransaction.transactionDetails?.customerReference ?? null,
            paid: balanceTransaction.transactionDetails?.paid ?? false
        }))
    );
}
